import { type CookieValueTypes, getCookie } from 'cookies-next/client';

import { DEBUG_PANEL_FORCE_ENV } from '@/constants/cookies';

export function getDebugPanelEnv(): CookieValueTypes {
  const panelEnv = getCookie(DEBUG_PANEL_FORCE_ENV);

  return panelEnv;
}
